import React from "react";
import { useEffect } from "react";

export default function User({ user, isAnonymus, eleRef }) {
    useEffect(() => {
        const lazyImages = document.querySelectorAll('.loadingImg[data-src]');
        lazyImages.forEach(img => {
            const dataSrc = img.getAttribute('data-src');
            if (dataSrc) {
                img.setAttribute('src', dataSrc);
                img.removeAttribute('data-src');
                img.classList.remove('loadingImg');
            }
        });
    }, []);
    return (
        <div className="experts-details discussion-expert">
            <span className="experts-photo">
                {user.userPhoto && user.userPhoto != '' && user.userPhoto.toLowerCase() != "null" ?
                    <img src={user.userPhoto.replace("http://", "https://")} onError={(e) => { e.target.src = 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png'}} alt="" className="loadingImg" />
                    :
                    <img src="https://cdn.cdnparenting.com/articles/2021/04/09155919/default-img.webp" onError={(e) => { e.target.src = 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png'}} alt="" className="loadingImg" />
                }
            </span>
            <span className="experts-name discussion-publisher">
                {user.userName && user.userName != '' && parseInt(isAnonymus) == 0 ?
                    <span className="exp-name M14_42">{user.userName}</span>
                    :
                    <span className="exp-name M14_42">Community User</span>
                }
                {user.userDesc && user.userDesc != '' && parseInt(isAnonymus) == 0 ?
                    <span className="R13_9e experts-desc">{user.userDesc}</span>
                    :
                    <span className="R13_9e experts-desc"></span>
                }
            </span>
            {user.commentDateTime && user.commentDateTime != '' ?
                <span className="experts-last-online-time R13_9e">{user.commentDateTime}</span>
                :
                <span className="experts-last-online-time R13_9e"></span>
            }
        </div>
    );
}
